import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { p as parseHrefProp } from './p-DlCOw5Kl.js';
import { d as defineCustomElement$1 } from './p-Dr61d_nc.js';

const hyperlinkCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border-radius:.125rem;box-sizing:border-box;cursor:pointer;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;max-width:fit-content}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host a{align-items:center;color:inherit;display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:600;gap:.25rem;letter-spacing:-.0004em;line-height:1.25rem;overflow:hidden;text-decoration:underline;text-overflow:ellipsis;white-space:nowrap}:host([type=regular]){color:var(--jw-theme-system-secondary-default-color)}:host([type=regular]:not([disabled]):hover){color:var(--jw-theme-system-secondary-hover-color)}:host([type=regular]:not([disabled]):active){color:var(--jw-theme-system-secondary-active-color)}:host([type=inverted]){color:var(--jw-theme-surface-bold-link-inverted-default-color)}:host([type=inverted]:not([disabled]):hover){color:var(--jw-theme-surface-bold-link-inverted-hover-color)}:host([type=inverted]:not([disabled]):active){color:var(--jw-theme-surface-bold-link-inverted-active-color)}:host(:not([disabled]):focus){outline:var(--jw-theme-effects-focus-default-outline)}:host([disabled]){cursor:not-allowed}";

const WuiHyperlink = /*@__PURE__*/ proxyCustomElement(class WuiHyperlink extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Hyperlink type
         */
        this.type = 'regular';
        /**
         * Text of hyperlink
         */
        this.label = 'Link';
    }
    render() {
        const parsedHrefProps = parseHrefProp(this.href, this.disabled);
        const isExternalLink = parsedHrefProps.href &&
            (parsedHrefProps.href.startsWith('http://') || parsedHrefProps.href.startsWith('https://'));
        const trailingIcon = isExternalLink ? 'external-link' : this.trailingIcon;
        return (h(Host, { key: '40ceaeaf1a2dc6070b2dce397197c8fad979db77' }, h("a", { key: '2e4bd6a2981ea7bd6dc636515be62e6fe9b66a3c', ...parsedHrefProps, ...(isExternalLink ? { target: '_blank', rel: 'noopener noreferrer' } : {}) }, this.leadingIcon && h("wui-icon", { key: 'de4b5bd0b3b974055b1395c1d55b6a933366972c', name: this.leadingIcon }), this.label, trailingIcon && h("wui-icon", { key: 'e7f28a987dacf677d1ba0eb535b21ea45797a7b1', name: trailingIcon }))));
    }
    static get style() { return hyperlinkCss; }
}, [257, "wui-hyperlink", {
        "type": [513],
        "label": [1],
        "href": [1],
        "leadingIcon": [1, "leading-icon"],
        "trailingIcon": [1, "trailing-icon"],
        "disabled": [516]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-hyperlink", "wui-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-hyperlink":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiHyperlink);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiHyperlink as W, defineCustomElement as d };
